<template>
  <!-- 内容区域 -->
  <div>
    <div class="dashboard-tab">
      <h3 class="tab-title">购物车</h3>
        <el-button type="text" @click="clearCart">
           <svg t="1766663210004" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5569" width="12" height="12"><path d="M696.32 778.24H345.6c-15.36 0-28.16-10.24-30.72-23.04L151.04 133.12H79.36c-17.92 0-33.28-15.36-33.28-30.72S61.44 71.68 76.8 71.68h97.28c15.36 0 28.16 10.24 30.72 23.04l163.84 619.52h325.12c17.92 0 30.72 15.36 30.72 30.72s-10.24 33.28-28.16 33.28z" fill="#1296db" p-id="5570"></path><path d="M785.92 663.04H335.36c-17.92 0-30.72-15.36-30.72-30.72s15.36-30.72 30.72-30.72h430.08L890.88 307.2h-40.96c-17.92 0-30.72-15.36-30.72-30.72s15.36-30.72 30.72-30.72h89.6c10.24 0 20.48 5.12 25.6 15.36 5.12 7.68 7.68 20.48 2.56 30.72l-153.6 358.4c-2.56 5.12-15.36 12.8-28.16 12.8z" fill="#1296db" p-id="5571"></path><path d="M555.52 517.12c-17.92 0-30.72-15.36-30.72-30.72V192c0-17.92 15.36-30.72 30.72-30.72s30.72 15.36 30.72 30.72V486.4c0 15.36-12.8 30.72-30.72 30.72zM340.48 954.88c-66.56 0-120.32-53.76-120.32-120.32s53.76-120.32 120.32-120.32S460.8 768 460.8 834.56s-53.76 120.32-120.32 120.32z m0-176.64c-30.72 0-56.32 25.6-56.32 56.32s25.6 56.32 56.32 56.32 56.32-25.6 56.32-56.32-25.6-56.32-56.32-56.32zM709.12 954.88c-66.56 0-120.32-53.76-120.32-120.32s53.76-120.32 120.32-120.32 120.32 53.76 120.32 120.32-53.76 120.32-120.32 120.32z m0-176.64c-30.72 0-56.32 25.6-56.32 56.32s25.6 56.32 56.32 56.32 56.32-25.6 56.32-56.32-23.04-56.32-56.32-56.32z" fill="#1296db" p-id="5572"></path><path d="M445.44 268.8c-7.68 0-15.36-2.56-20.48-7.68-15.36-10.24-15.36-30.72-2.56-43.52l110.08-122.88c5.12-7.68 15.36-10.24 23.04-10.24 10.24 0 17.92 2.56 23.04 10.24L691.2 217.6c12.8 12.8 10.24 33.28-2.56 46.08s-33.28 10.24-46.08-2.56l-89.6-97.28-87.04 97.28c-2.56 5.12-12.8 7.68-20.48 7.68z" fill="#1296db" p-id="5573"></path></svg>
            清空购物车
          </el-button>
    <!-- 购物车区域 -->
      <div v-if="cartItems.length > 0" class="shopping-cart-section">
        <el-table :data="cartItems" class="cart-table">
          <el-table-column prop="itemName" label="商品名称" width="400">
            <template #default="scope">
              <div class="cart-item-name">
                <svg v-if="scope.row.itemType >= 1 && scope.row.itemType < 5"  t="1769565653636" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5632" width="20" height="20"><path d="M0 0h1024v1024H0V0z" fill="#202425" opacity=".01" p-id="5633"></path><path d="M204.8 34.133333a34.133333 34.133333 0 0 0-34.133333 34.133334v238.933333a34.133333 34.133333 0 0 0 34.133333 34.133333h238.933333a34.133333 34.133333 0 0 0 34.133334-34.133333V68.266667a34.133333 34.133333 0 0 0-34.133334-34.133334H204.8z m514.423467 24.132267a34.133333 34.133333 0 0 0-48.264534 0l-168.96 168.96a34.133333 34.133333 0 0 0 0 48.264533l168.96 168.96a34.133333 34.133333 0 0 0 48.264534 0l168.96-168.96a34.133333 34.133333 0 0 0 0-48.264533l-168.96-168.96z" fill="#FFAA44" p-id="5634"></path><path d="M102.4 341.333333a34.133333 34.133333 0 0 1 34.133333-34.133333h750.933334a34.133333 34.133333 0 0 1 34.133333 34.133333v614.4a34.133333 34.133333 0 0 1-34.133333 34.133334H136.533333a34.133333 34.133333 0 0 1-34.133333-34.133334V341.333333z" fill="#11AA66" p-id="5635"></path><path d="M238.933333 512a273.066667 273.066667 0 1 0 546.133334 0v-68.266667a34.133333 34.133333 0 1 0-68.266667 0v68.266667a204.8 204.8 0 0 1-409.6 0v-68.266667a34.133333 34.133333 0 1 0-68.266667 0v68.266667z" fill="#FFFFFF" p-id="5636"></path></svg>
                <svg  v-if="scope.row.itemType === 5" t="1769566347946" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7474" width="20" height="20"><path d="M698.0263 16.236849c171.185017 30.258814 274.070106 129.047955 306.863288 299.157786 25.343677 131.479924 25.727672 264.34223-0.383995 395.694155-35.071553 166.423478-144.382159 269.154968-310.012048 297.23781-122.904033 20.863734-245.859265 21.119731-368.532901-0.563193C154.775627 977.504593 51.429744 873.774715 18.636562 703.664884c-26.623661-132.350313-24.063693-266.057408 3.404757-398.894114C56.677677 137.220906 163.249119 43.858897 329.467799 15.673656c122.904033-20.863734 245.859265-21.119731 368.532901 0.563193zM531.193227 247.043506h-206.23097l-3.763152 0.153598-3.891151 0.460794a49.023375 49.023375 0 0 0-40.75468 48.511382v413.076333l-2.764765 0.435195-3.225559 0.844789a33.945167 33.945167 0 0 0-23.5261 32.460386c0 18.79016 15.001409 33.970767 33.535573 33.970767h295.266635l3.430356-0.179198a33.791569 33.791569 0 0 0 30.079617-33.791569c0-16.46059-11.494253-30.130816-26.751659-33.279576l-2.534368-0.409595v-202.749414h26.367664l1.56158 0.230397c2.508768 0.691191 4.351945 3.071961 4.351945 5.990323v140.235012l0.153598 4.249546c2.739165 37.964316 41.957865 69.656712 82.405349 69.656712 41.881066 0 82.046954-34.047566 82.046954-73.906258V383.105771l-0.179198-4.863938a59.365643 59.365643 0 0 0-17.356579-37.58032l-52.402531-52.658529-2.687966-2.457569a32.869981 32.869981 0 0 0-44.287435 2.508768l-2.40637 2.713566-2.047974 2.918363a33.996367 33.996367 0 0 0 4.454344 41.804266l27.724446 28.441238-19.122956 20.223742-2.303971 2.687966c-9.190283 12.134245-8.422293 29.490824 2.431969 40.549883l2.457569 2.35517 2.713565 2.022374c4.73594 3.097561 10.342268 4.787139 16.102195 4.787139h19.378953v205.846975l-0.127998 2.35517c-0.895989 7.731101-6.27192 14.438216-14.847811 14.438216-9.574278 0-15.513402-8.371093-15.513402-16.793386V512.512121l-0.127999-4.351944-0.383995-4.454343c-4.275145-36.83793-34.994754-65.330367-72.447076-65.330367l-26.393264-0.0256v-142.180587l-0.127998-3.839951c-1.945575-25.241278-22.809309-45.285823-48.255385-45.285823z m-29.618822 53.272921c14.847811 0 26.751659 10.495866 26.751659 23.5517v94.795591l-0.179198 2.739165c-1.53598 11.77585-12.799837 20.786935-26.572461 20.786935h-145.841341l-3.12316-0.153598c-13.36303-1.356783-23.628499-11.263856-23.628499-23.372502V323.842527l0.179198-2.764765c1.53598-11.724651 12.799837-20.786935 26.572461-20.786935z" fill="#0088FF" p-id="7475"></path></svg>
                {{ scope.row.itemName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="unitPrice" label="单价" width="180" align="center">
            <template #default="scope">¥{{ scope.row.unitPrice }}</template>
          </el-table-column>
          <el-table-column label="数量" width="120" align="center">
            <template #default="scope">
              <el-input-number v-if="scope.row.itemType==5" v-model="scope.row.quantity" size="mini" 
                :min="1" :max="99" @change="updateCartItem(scope.row)"></el-input-number>
              <a v-else>{{scope.row.quantity }}</a>                
            </template>
          </el-table-column>
          <el-table-column label="小计" width="180" align="center">
            <template #default="scope">
              <span class="subtotal">¥{{ (scope.row.unitPrice * scope.row.quantity).toFixed(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="140" align="center">
            <template #default="scope">
              <el-button type="danger" icon="el-icon-delete" size="mini" 
                @click="removeFromCart(scope.row.id)"></el-button>
            </template>
          </el-table-column>
        </el-table>
              
        <div class="cart-summary">
          <div class="summary-left">
            <!-- 可以放一些左侧内容，比如全选按钮 -->
          </div>
          <div class="summary-right">
            <div class="summary-row">
              <div class="summary-item total-price">
                合计：<span class="price">¥{{ formatPrice(cartTotal) }}</span>
              </div>
              <div class="summary-item total-discount">
                优惠：
                 <span class="price discount-price">-¥{{ formatPrice(total_discount) }}</span>
                <span class="discount-toggle" @click="show_discount_details = !show_discount_details">
                  <svg v-if="!show_discount_details" t="1766663834971" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7306" width="12" height="12">
                    <path d="M849.069 78.631c8.212-9.321 19.351-14.355 30.666-14.915 11.333-0.542 22.869 3.381 31.912 11.868 9.020 8.509 13.89 20.015 14.438 31.705 0.524 11.687-3.279 23.625-11.491 32.941l-366.287 375.687c-8.192 9.183-19.221 14.102-30.449 14.646-11.316 0.565-22.844-3.34-31.888-11.848l-0.217-0.202h-0.023v-0.023l-1.183-1.148-0.213-0.249-1.138-1.222v0.024l-0.090-0.087-0.239-0.299-0.15-0.156-365.77-375.125c-8.235-9.316-12.010-21.254-11.485-32.941 0.542-11.69 5.393-23.196 14.438-31.705 9.020-8.487 20.573-12.411 31.888-11.868 11.312 0.559 22.454 5.593 30.689 14.915l333.283 338.319 333.309-338.319zM849.069 78.631z" p-id="7307" fill="#1296db"></path>
                    <path d="M849.069 441.638c8.212-9.344 19.351-14.352 30.666-14.916 11.333-0.542 22.869 3.362 31.912 11.87 9.020 8.484 13.89 19.991 14.438 31.7 0.524 11.69-3.279 23.606-11.491 32.944l-366.287 375.667c-8.192 9.187-19.221 14.127-30.449 14.668-11.316 0.541-22.844-3.341-31.888-11.848l-0.217-0.202-0.023-0.021-1.183-1.176-0.213-0.226-1.138-1.217v0.023l-0.090-0.091-0.239-0.295-0.151-0.181-365.769-375.101c-8.235-9.339-12.010-21.254-11.485-32.944 0.542-11.709 5.393-23.216 14.438-31.7 9.020-8.508 20.573-12.412 31.888-11.87 11.312 0.564 22.454 5.572 30.689 14.916l333.283 338.297 333.309-338.297zM849.069 441.638z" p-id="7308" fill="#1296db"></path>
                  </svg>
                  <svg v-if="show_discount_details" t="1766739404396" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5544" width="12" height="12">
                    <path d="M84.61 536.154c19.381 19.38 50.622 19.38 70.002 0l358.69-358.69 358.689 358.69c19.38 19.38 50.621 19.38 70.002 0 19.381-19.381 19.381-50.622 0-70.003l-393.69-393.69c-19.381-19.38-50.622-19.38-70.002 0L84.61 466.151c-19.237 19.381-19.237 50.622 0 70.003z" fill="#1296db" p-id="5545"></path>
                    <path d="M548.303 488.57c-19.381-19.381-50.622-19.381-70.002 0L84.61 882.114c-19.382 19.381-19.382 50.622 0 70.003 19.38 19.38 50.62 19.38 70.001 0l358.69-358.69 358.689 358.69c19.38 19.38 50.621 19.38 70.002 0 19.381-19.381 19.381-50.622 0-70.003L548.303 488.57z" fill="#1296db" p-id="5546"></path>
                  </svg>
                  <span class="toggle-text">{{ show_discount_details ? '收起' : '明细' }}</span>
                </span>
              </div>
            </div>
            
            <!-- 优惠明细区域 -->
            <div v-if="show_discount_details && promotions_used.length > 0" class="discount-details">
              <div class="discount-details-title">优惠明细</div>
              <div v-for="promotion in promotions_used" :key="promotion.id" class="promotion-item">
                <div class="promotion-header">
                  <span class="promotion-name">{{ promotion.activityName }}</span>
                 <span class="promotion-amount">-¥{{ formatPrice(promotion.discount) }}</span>
                </div>
<!--                <div v-if="promotion.activityType === 1" class="promotion-desc">
                  {{ (promotion.discountRate / 100).toFixed(1) }}折优惠
                </div>
                <div v-else-if="promotion.activityType === 2" class="promotion-desc">
                  满{{ promotion.minAmount }}减{{ promotion.reduceAmount }}
                </div>
                <div v-else class="promotion-desc">
                  立减{{ promotion.reduceAmount }}元
                </div> -->
              </div>
            </div>
            
            <!-- 实付金额和结算按钮 -->
            <div class="final-section">
              <div class="real-pay">
                实付金额：
                <span class="real-pay-amount">¥{{ formatPrice(cartTotal - total_discount) }}</span>
              </div>
              <el-button 
                type="success" 
                size="medium" 
                class="checkout-btn"
                @click="goToCheckout"
              >
                <i class="el-icon-wallet"></i> 去结算
              </el-button>
            </div>
          </div>
        </div>
      </div>   
      <img v-else src="https://aics-public.oss-cn-beijing.aliyuncs.com/images/none.png" class="aics-background"/>  
    </div>
  </div>
</template>

<script>

import { getCartItems, updateCartItem, 
        removeCartItem, clearCart, listPromotions,calculatePromotions } from '@/api/tenant/cart'


export default {
  name: "CartView",
  data() {
    return {    
      //套餐相关
      version_settings: [],
      current_version_setting: null,
      // 加油包相关
      fuelPackages: [],
      selectedFuelPackage: null,      
      // 优惠活动相关
      promotions:[],
      total_discount:0,
      show_discount_details: false,
      promotions_used: [],
      // 购物车相关g
      cartItems: [],
      cartTotal: 0,
      loading: false, // 新增loading状态
    cartVersion: 1, // 购物车版本，防止旧数据
    lastCartUpdate: null, // 最后更新时间
      open: false, // 弹窗状态

      versionCode: '', // 选择的套餐编码
    }
  },
  computed: {
    tenantInfo() {
      return this.$store.getters['auth/currentTenant'];
    },
    tenantId() {
      return this.tenantInfo?.tenantId || null;
    }
  },
  async mounted() {
    console.log(this.tenantInfo);
    if(this.tenantInfo && this.tenantInfo.status && this.tenantInfo.status.trim()!=='APPROVED'){
    this.$message.error('租户状态未激活');  
    this.logout();
}  
    let response = await listPromotions()
    console.log("listPromotions():", response)
    this.promotions = response.data.data;
    console.log(this.promotions);
    this.loadCartItems();
  },
  methods: {
    // 1. 获取优惠计算结果的方法
    async calculatePromotions() {
        try {
            const response = await calculatePromotions(); 
            this.total_discount = response.data.discountAmount;
            this.promotions_used = response.data.appliedPromotions;
            console.log("calculatePromotions",this.total_discount, this.promotions_used )
        } catch (error) {
            console.error("获取优惠计算结果失败:", error);
            // 降级方案：使用前端计算（临时）
            this.calculateDiscountFallback();
        }
    },    
    // 2. 简化版前端计算（降级方案）
    calculateDiscountFallback() {
        // 只做简单的折扣计算，避免复杂逻辑
        this.total_discount = 0;
        this.promotions_used = [];
        
        // 简单示例：如果有打折活动，统一打9折
        const hasDiscount = this.promotions.some(p => 
            p.status === 1 && 
            p.activityType === 1 && // 折扣类型
            new Date(p.startTime) <= new Date() &&
            new Date(p.endTime) >= new Date()
        );
        
        if (hasDiscount) {
            // 简单计算：总价打9折
            const discount = this.cartTotal * 0.1;
            this.total_discount = Math.round(discount * 100) / 100;
            
            this.promotions_used.push({
                activityName: '通用折扣',
                discount: this.total_discount,
                activityType: 1
            });
        }
    },    
    // 3. 修改formatPrice方法，确保正确处理小数
    formatPrice(price) {
        if (price === null || price === undefined) return '0.00';
        
        // 如果是字符串，转换为数字
        const num = typeof price === 'string' ? parseFloat(price) : price;
        
        // 确保是数字且有效
        if (isNaN(num)) return '0.00';
        
        // 四舍五入到2位小数
        return Math.round(num * 100) / 100;
    },    
    // 向上取整金额（用于优惠计算）
    ceilPrice(price) {
      return Math.ceil(price * 100) / 100; // 向上取整到分
    },
    
    // 或者如果后端已经转了元，直接格式化
    formatPriceYuan(price) {
      return parseFloat(price).toFixed(2);
    },

    // 获取状态显示文本
    getStatusText(status) {
      const statusTextMap = {
        'active': '已启用',
        'disabled': '已禁用',

      };
      return statusTextMap[status] || status;
    },

    
    // 加载购物车
    loadCartItems() {
      getCartItems().then(response => {
        console.log("购物车数据:", response)
           const now = Date.now();
        this.cartItems = response.data.data.filter(item => {
          // 过滤过期商品（超过7天）
          return !item.expireTime || item.expireTime > now;
        });    
 console.log("过滤后的购物车数据:", response)
        // 确保unitPrice是数字类型
        this.cartItems.forEach(item => {
          item.unitPrice = parseFloat(item.unitPrice);
        });
        console.log(this.cartItems)
        this.calculateTotal();
      }).catch(error => {
        console.error("加载购物车失败:", error);
      });
    },      

    
    // 更新购物车项
    updateCartItem(item) {
      item.newItemId= item.itemId
      updateCartItem(item).then(response => {
        console.log(response);        
        this.cartTotal =  this.calculateTotal();
        console.log(this.cartTotal);
        // this.calculateDiscount();
        this.$message.success('已更新');
      }).catch(error => {
        this.$message.error('更新失败'+error);
      });
    },
    
    // 从购物车移除
    removeFromCart(id) {
      this.$confirm('确定要从购物车移除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeCartItem(id).then(response => {
          console.log(response);
          this.loadCartItems();
          this.$message.success('已移除');
        }).catch(error => {
          this.$message.error('移除失败'+error);
        });
      });
    },
    
    // 清空购物车
    clearCart() {
      this.$confirm('确定要清空购物车吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        clearCart().then(response => {
        console.log(response);          
          this.cartItems = [];
          this.cartTotal = 0;
          this.$message.success('购物车已清空');
        }).catch(error => {
          this.$message.error('清空失败'+error);
        });
      });
    },   

    calculateDiscount() {
        // 重新初始化
        this.promotions_used = [];
        
        // 先将所有金额转换为元进行计算（避免分单位混乱）
        console.log("=== 开始计算折扣 ===");
        
        // 按商品类型分组
        const planItems = this.cartItems.filter(item => item.itemType === 1);
        const planRenewItems = this.cartItems.filter(item => item.itemType === 2);
        const planUpgradeItems = this.cartItems.filter(item => item.itemType === 3);      
        const fuelItems = this.cartItems.filter(item => item.itemType === 4);

        // 计算各类商品总价（元）
        const planTotal = planItems.reduce((sum, item) => 
            sum + (item.unitPrice * item.quantity), 0);
        
        const planRenewTotal = planRenewItems.reduce((sum, item) => 
            sum + (item.unitPrice * item.quantity), 0);

        const planUpgradeTotal = planUpgradeItems.reduce((sum, item) => 
            sum + (item.unitPrice * item.quantity), 0);        

        const fuelTotal = fuelItems.reduce((sum, item) => 
            sum + (item.unitPrice * item.quantity), 0);
        
        const cartTotal = planTotal + planRenewTotal + planUpgradeTotal + fuelTotal;
        
        // 更新购物车总价
        this.cartTotal = this.formatPrice(cartTotal);
        
        console.log("购物车统计:");
        console.log("- 套餐新购总价:", planTotal.toFixed(2), "元");
        console.log("- 套餐续费总价:", planRenewTotal.toFixed(2), "元");
        console.log("- 套餐升级总价:", planUpgradeTotal.toFixed(2), "元");
        console.log("- 加油包总价:", fuelTotal.toFixed(2), "元");
        console.log("- 合计:", cartTotal.toFixed(2), "元");
        
        // 已享受优惠的商品ID集合
        const discountedItemIds = new Set();
        let totalDiscount = 0;
        
        // 按优先级排序优惠活动
        const sortedPromotions = [...this.promotions].sort((a, b) => b.priority - a.priority);
        
        console.log("检查优惠活动，数量:", sortedPromotions.length);
        
        sortedPromotions.forEach((promotion, index) => {
            console.log(`\n[${index}] 检查活动: ${promotion.activityName} (类型: ${promotion.activityType})`);
            
            // 检查活动状态
            if (promotion.status !== 1) {
                console.log("  × 活动未启用，跳过");
                return;
            }
            
            // 检查活动时间
            const now = new Date();
            const startTime = new Date(promotion.startTime);
            const endTime = new Date(promotion.endTime);
            
            if (now < startTime) {
                console.log("  × 活动未开始，跳过");
                return;
            }
            if (now > endTime) {
                console.log("  × 活动已结束，跳过");
                return;
            }
            
            let applicableItems = [];
            let itemTotal = 0;
            
            // 根据目标类型确定适用商品
            switch(promotion.targetType) {
                case 1: // 全部商品
                    applicableItems = this.cartItems;
                    itemTotal = cartTotal;
                    console.log("  ✓ 适用全部商品");
                    break;
                    
                case 2: // 套餐
                    // 合并所有类型的套餐商品
                    applicableItems = [...planItems, ...planRenewItems, ...planUpgradeItems];
                    itemTotal = planTotal + planRenewTotal + planUpgradeTotal;
                    console.log("  ✓ 适用所有套餐商品");
                    
                    // 如果指定了特定套餐，进一步筛选
                    if (promotion.products && promotion.products.length > 0) {
                        const specificPlanIds = promotion.products
                            .filter(p => p.productType === 1)
                            .map(p => p.productId);            

                        if (specificPlanIds.length > 0) {
                            console.log("  - 指定套餐ID:", specificPlanIds);
                            
                            applicableItems = applicableItems.filter(item => 
                                specificPlanIds.includes(item.itemId)
                            );
                            
                            itemTotal = applicableItems.reduce((sum, item) => 
                                sum + (item.unitPrice * item.quantity), 0);
                            console.log("  - 筛选后适用商品数:", applicableItems.length);
                        }      
                    }      
                    break;
                    
                case 3: // 加油包
                    applicableItems = fuelItems;
                    itemTotal = fuelTotal;
                    console.log("  ✓ 适用加油包");
                    
                    // 如果指定了特定加油包，进一步筛选
                    if (promotion.products && promotion.products.length > 0) {
                        const specificFuelIds = promotion.products
                            .filter(p => p.productType === 2)
                            .map(p => p.productId);
                        
                        if (specificFuelIds.length > 0) {
                            console.log("  - 指定加油包ID:", specificFuelIds);
                            applicableItems = fuelItems.filter(item => 
                                specificFuelIds.includes(item.itemId)
                            );
                            itemTotal = applicableItems.reduce((sum, item) => 
                                sum + (item.unitPrice * item.quantity), 0);
                            console.log("  - 筛选后适用商品数:", applicableItems.length);
                        }
                    }
                    break;
            }
            
            // 检查最低消费门槛（元）
            const minAmount = promotion.minAmount || 0;
            console.log(`  - 最低消费门槛: ${minAmount}元`);
            console.log(`  - 适用商品总价: ${itemTotal.toFixed(2)}元`);
            
            if (itemTotal < minAmount) {
                console.log("  × 未达到最低消费门槛，跳过");
                return;
            }
            console.log("  ✓ 达到最低消费门槛");
            
            // 排除已享受优惠的商品
            const newApplicableItems = applicableItems.filter(item => 
                !discountedItemIds.has(item.id)
            );
            
            console.log(`  - 适用商品数: ${applicableItems.length}, 未享受优惠数: ${newApplicableItems.length}`);
            
            if (newApplicableItems.length === 0) {
                console.log("  × 所有适用商品都已享受过优惠，跳过");
                return;
            }
            
            // 重新计算适用商品的总价（元）
            const newApplicableTotal = newApplicableItems.reduce((sum, item) => 
                sum + (item.unitPrice * item.quantity), 0);
            
            console.log(`  - 未享受优惠商品总价: ${newApplicableTotal.toFixed(2)}元`);
            
            // 计算优惠金额（元）
            let discount = 0;
            let discountPercent = 0;
            
            switch(promotion.activityType) {
                case 1: // 折扣
                    // discountRate是千分比，如900表示9折（优惠10%）
                    // 优惠金额 = 总价 × (1 - discountRate/1000)
                    discountPercent = (1000 - promotion.discountRate) / 1000;
                    discount = newApplicableTotal * discountPercent;
                    console.log(`  ✓ 折扣计算: 折扣率=${discountPercent}, 优惠=${discount.toFixed(2)}元`);
                    break;
                    
                case 2: // 满减
                    // 已经检查了 minAmount 门槛
                    // 满足门槛后减免 reduceAmount
                    if (promotion.reduceAmount) {
                        discount = promotion.reduceAmount;
                        console.log(`  ✓ 满减计算: 减免${promotion.reduceAmount}元, 优惠=${discount.toFixed(2)}元`);
                    } else {
                        console.log("  × 满减活动缺少 reduceAmount，跳过");
                        return;
                    }
                    break;
                    
                case 3: // 立减
                    // 无条件直接减免
                    if (promotion.reduceAmount) {
                        discount = promotion.reduceAmount;
                        console.log(`  ✓ 立减计算: 减免${promotion.reduceAmount}元, 优惠=${discount.toFixed(2)}元`);
                    } else {
                        console.log("  × 立减活动缺少 reduceAmount，跳过");
                        return;
                    }
                    break;
                    
                default:
                    console.log(`  × 未知活动类型: ${promotion.activityType}，跳过`);
                    return;
            }
            
            // 确保折扣不超过商品总价
            discount = Math.min(discount, newApplicableTotal);
            
            if (discount > 0) {          
                // 保留2位小数
                discount = Math.round(discount * 100) / 100;
                
                console.log(`  ✓ 最终优惠: ${discount.toFixed(2)}元`);
                
                // 记录优惠详情
                this.promotions_used.push({
                    id: promotion.id,
                    activityName: promotion.activityName,
                    activityType: promotion.activityType,
                    targetType: promotion.targetType,
                    discountRate: promotion.discountRate,
                    minAmount: promotion.minAmount,
                    reduceAmount: promotion.reduceAmount,
                    discount: discount,
                    itemTotal: newApplicableTotal,
                    items: newApplicableItems.map(item => item.itemName)
                });
                
                // 累加总折扣
                totalDiscount += discount;
                
                // 标记商品已享受优惠
                newApplicableItems.forEach(item => discountedItemIds.add(item.id));
                
                console.log(`  ✓ 已标记 ${newApplicableItems.length} 个商品享受优惠`);
            } else {
                console.log("  × 优惠金额为0，跳过");
            }
        });
        
        // 计算总折扣
        this.total_discount = Math.round(totalDiscount * 100) / 100;
        
        console.log("\n=== 计算完成 ===");
        console.log("总折扣（元）:", this.total_discount.toFixed(2));
        console.log("应用优惠数量:", this.promotions_used.length);
        
        // 验证明细合计是否等于总优惠
        const detailSum = this.promotions_used.reduce((sum, p) => 
            sum + p.discount, 0);
        
        if (Math.abs(detailSum - this.total_discount) > 0.01) {
            console.warn("⚠️ 优惠金额不一致，明细合计:", detailSum.toFixed(2), "总优惠:", this.total_discount.toFixed(2));
            // 强制保持一致
            this.total_discount = Math.round(detailSum * 100) / 100;
        }
    },

    // 去结算
    goToCheckout() {
      
      if (this.cartItems.length === 0) {
        this.$message.warning('购物车为空');
        return;
      }
      
      // 跳转到结算页面
      this.$router.push({
        path: '/admin/order/checkout',
        query: {
          cartData: JSON.stringify({
            items: this.cartItems,
            // 可以传递前端计算的优惠，但仅作参考
            frontendDiscount: this.total_discount
          })
        }
      });
    },
    
    // 查看购物车
    goToCart() {
      this.open = false;
      // 如果购物车为空，显示提示
      if (this.cartItems.length === 0) {
        this.$message.info('购物车为空，请先添加商品');
      }
    },
    
    // 格式化日期
    formatDate(date) {
      if (!date) return '';
      return new Date(date).toLocaleDateString();
    },   
    reset() {
      this.versionCode = '';     
    },
    /** 提交按钮 */
    submitForm: function () {
    
    },

    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    HandleSelect(versionCode){

      this.versionCode = versionCode;
      for(let i=0;i<this.version_settings.length;i++){
        if(this.version_settings[i].versionCode === this.versionCode){
          this.current_version_setting = this.version_settings[i];
          break;
        }       
      }
      console.log(this.current_version_setting);
    },

    async loadPromotions() {
        try {
            // 调用统一接口
            const response = await calculatePromotions();
            console.log("loadPromotions", response);
                        console.log("loadPromotions response.data.code:", response.data.code);
            if (response.data.code == 200) {
                const result = response.data.data;
                console.log("result", result)

                this.updateCartWithUnifiedResult(result);
            }
        } catch (error) {
            console.error("加载优惠信息失败:", error);
            this.calculateDiscount(); // 降级方案
        }
    },

    async calculatePromotionsFromBackend() {
      console.log("calculatePromotionsFromBackend");
        try {
            // 调用后端API计算优惠
            const response = await this.$http.get('/aics/cart/calculate-promotions');
            if (response.data.success) {
                const result = response.data.data;
                this.total_discount = result.discountAmount;
                
                // 转换后端返回的优惠列表格式
                this.promotions_used = result.appliedPromotions.map(promotion => ({
                    id: promotion.promotionId,
                    activityName: promotion.promotionName,
                    activityType: promotion.promotionType,
                    discount: promotion.discountAmount,
                    description: promotion.description,
                    appliedItemNames: promotion.appliedItemNames || []
                }));
                
                console.log("后端优惠计算完成:", result);
            } else {
                throw new Error(response.data.message || "计算优惠失败");
            }
        } catch (error) {
            console.error("调用后端优惠计算失败:", error);
            // 降级方案：使用前端计算
            this.calculateDiscount();
        }
    },

// 修改mounted方法
async mounted() {
      console.log("mounted")
    console.log(this.tenantInfo);
    await this.loadPromotions();
    this.loadCartItems();


},


    calculateTotal() {
        this.cartTotal = this.cartItems.reduce((total, item) => {
          console.log("calculateTotal", total, item)
            return total + (item.unitPrice * item.quantity);
        }, 0);
        
        // 重新计算优惠
        this.loadPromotions();
    },   
    
    updateCartWithUnifiedResult(result) {
      console.log("updateCartWithUnifiedResult", result)
        // 更新购物车显示
        this.cartTotal = result.originalTotal;
        this.total_discount = result.discountAmount;
        
        // 转换优惠列表格式
        console.log("result.appliedPromotions",result.applied_promotions)
        this.promotions_used = result.applied_promotions.map(promotion => ({
            id: promotion.promotion_id,
            /*activityName: promotion.promotionName,
            activityType: promotion.promotionType,
            discount: promotion.discountAmount,*/
            
            activityName: promotion.promotion_name,
            activityType: promotion.promotion_type,
            targetType: promotion.target_type,
            discountRate: promotion.discount_rate,
            minAmount: promotion.minAmount,
            reduceAmount: promotion.reduceAmount,
            discount:promotion.discount_amount,
            itemTotal: promotion.newApplicableTotal,
             //items: promotion.newApplicableItems.map(item => item.itemName)            
            
        }));
        
        console.log("统一价格计算完成:",this.promotions_used,result);

        if(result){
           this.cartTotal = result.original_total;
           this.total_discount = result.discount_amount;
           console.log("this.cartTotal", this.cartTotal)  
        }
    },
    async logout() {
      try {
        // 调用 Vuex 中的 logout action
        await this.$store.dispatch('auth/logout')
        // 退出成功后跳转到登录页
        this.$router.push('/login')
      } catch (error) {
        console.error('退出登录失败:', error)
        // 即使退出API调用失败，也强制清除本地状态并跳转
        this.$store.commit('auth/CLEAR_AUTH')
        this.$router.push('/login')
      }
    },      
  }
}
</script>

<style scoped>
/* 仪表盘样式 */
.dashboard-tab {
  padding: 0;
}

.tab-title {
  color: #333;
  margin-bottom: 25px;
  font-size: 1.5rem;
  font-weight: 500;
}

.info-section {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 15px;
}
.content{
    padding: 5px 5px 5px 5px;
}
.info-text {
  color: #666;
  font-size: 1rem;
  
}

.button-group {
  display: flex;
  gap: 10px;
}

/* 表格样式优化 */
.custom-table {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.custom-table ::v-deep .custom-header th {
  background-color: #f5f7fa;
  color: #606266;
  font-weight: 600;
  padding: 12px 10px;
}

.custom-table ::v-deep .custom-row td {
  padding: 12px 10px;
  border-bottom: 1px solid #ebeef5;
}

.custom-table ::v-deep .custom-row:hover td {
  background-color: #f5f7fa;
}

/* 头像样式 */
.avatar-placeholder {
  font-weight: bold;
  color: #fff;
}

/* 文本样式 */
.name-text {
  font-weight: 500;
  color: #303133;
}

.phone-text, .email-text {
  color: #606266;
}

/* 状态标签样式 */
.status-tag {
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 12px;
  min-width: 60px;
  text-align: center;
}

/* 操作按钮样式 */
.custom-table ::v-deep .action-btn {
  margin: 0 2px;
  border-radius: 4px;
}

/* 弹窗样式优化 */
.employee-dialog ::v-deep .el-dialog {
  border-radius: 8px;
}

.employee-dialog ::v-deep .el-dialog__header {
  border-bottom: 1px solid #ebeef5;
  padding: 15px 20px;
}

.employee-dialog ::v-deep .el-dialog__title {
  font-size: 1.2rem;
  font-weight: 500;
  color: #303133;
}

.employee-dialog ::v-deep .el-form-item__label {
  font-weight: 500;
  color: #606266;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .info-section {
    flex-direction: column;
    align-items: flex-start;
  }

  .button-group {
    width: 100%;
    justify-content: flex-end;
  }
  .status-tag {
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 12px;
  min-width: 60px;
  text-align: center;
   }
}

.aics-background{
    display: block;
  margin:  20px auto 20px auto;
  opacity: 0.3;
  border-radius: 50%;
}
.selector ul{
  display: flex;
  list-style: none;  
}
.selector ul li{
  display: flex-inline;
  margin-left: 20px;
  cursor: pointer;
}


.plans-table-container, .addons-table-container {
  overflow-x: auto;
}
.plans-table, .addons-table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 0.9rem;
}
.plans-table th, .plans-table td,
.addons-table th, .addons-table td {
  padding: 12px 15px;
  text-align: center;
  border: 1px solid #e0e0e0;
}
.plans-table th, .addons-table th {
  background-color: #f5f5f5;
  font-weight: 600;
  color: #333;
}
.plans-table .feature-col {
  width: 25%;
  text-align: left;
  background-color: #f9f9f9;
  font-weight: 500;
}
.plans-table .plan-col {
  width: 18.75%;
}
.plans-table .feature-name {
  text-align: left;
  background-color: #f9f9f9;
  font-weight: bold;
}
.plans-table .plan-feature {
  color: #555;
}
.plans-table .price-row .plan-feature {
  font-weight: 600;
  color: #333;
}
.addons-table .addon-feature-col {
  width: 25%;
  text-align: left;
  background-color: #f9f9f9;
  font-weight: 500;
}
.addons-table .addon-col {
  width: 25%;
}

@media (max-width: 1200px) {
  .flowchart {
    min-width: 1000px;
  }

  .step-text {
    font-size: 0.8rem;
    max-width: 70px;
  }
}
.active{
  font-family: 微软雅黑;
  font-weight: bold;
  font-size: 1.1rem;
  color: rgb(64, 158, 255);
}
/* 购物车汇总区域样式 */
.cart-summary {
  display: flex;
  justify-content: flex-end;
  margin: 20px 0;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}

.summary-left {
  flex: 1;
}

.summary-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  min-width: 300px;
}

/* 第一行：合计和优惠 */
.summary-row {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
  margin-bottom: 15px;
}

.summary-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  font-size: 14px;
  color: #666;
  width: 100%;
  justify-content: flex-end;
}

.total-price {
  font-size: 16px;
  color: #333;
  font-weight: 500;
}

.total-price .price {
  color: #e4393c;
  font-size: 20px;
  font-weight: bold;
  margin-left: 5px;
}

.total-discount {
  display: flex;
  align-items: center;
}

.discount-price {
  color: #67c23a;
  font-weight: bold;
  margin-left: 5px;
}

.discount-toggle {
  display: flex;
  align-items: center;
  margin-left: 10px;
  color: #1296db;
  cursor: pointer;
  font-size: 12px;
}

.discount-toggle:hover {
  color: #409eff;
}

.discount-toggle .icon {
  margin-right: 2px;
}

.toggle-text {
  font-size: 12px;
}

/* 优惠明细区域 */
.discount-details {
  width: 100%;
  margin: 10px 0;
  padding: 15px;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.discount-details-title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
  padding-bottom: 5px;
  border-bottom: 1px solid #f0f0f0;
}

.promotion-item {
  padding: 8px 0;
  border-bottom: 1px dashed #f0f0f0;
}

.promotion-item:last-child {
  border-bottom: none;
}

.promotion-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 3px;
}

.promotion-name {
  font-size: 13px;
  color: #333;
  flex: 1;
}

.promotion-amount {
  font-size: 13px;
  color: #67c23a;
  font-weight: bold;
  margin-left: 10px;
}

.promotion-desc {
  font-size: 12px;
  color: #888;
  text-align: right;
}

/* 实付金额和结算按钮区域 */
.final-section {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #e0e0e0;
}

.real-pay {
  font-size: 16px;
  color: #333;
  font-weight: 500;
  margin-right: 20px;
}

.real-pay-amount {
  font-size: 24px;
  font-weight: bold;
  color: #e4393c;
  margin-left: 5px;
}

.checkout-btn {
  height: 46px;
  padding: 0 30px;
  font-size: 16px;
  border-radius: 4px;
  background-color: #67c23a;
  border-color: #67c23a;
}

.checkout-btn:hover {
  background-color: #5daf34;
  border-color: #5daf34;
}
.cart-table{
  margin: 0 auto 0 auto;
  width: 1024px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .cart-summary {
    flex-direction: column;
    padding: 15px;
  }
  
  .summary-right {
    min-width: 100%;
    align-items: stretch;
  }
  
  .summary-row {
    align-items: flex-start;
  }
  
  .final-section {
    flex-direction: column;
    align-items: stretch;
  }
  
  .real-pay {
    margin-right: 0;
    margin-bottom: 15px;
    text-align: center;
  }
  
  .checkout-btn {
    width: 100%;
  }
}
</style>